import React from 'react';
import { Loading, SystemText } from '@salesperformanceint/e4shared';
import { useSelector } from 'react-redux';
import PageHeader from 'components/general/pageHeader';
import { e4Format, isFuture } from 'helpers/dates';
import { apiGet } from 'services';
import { ReviewDetails } from './components/details';
import ReviewsList from './components/list';

export const Reviews = ({ history }) => {
    const [loading, setLoading] = React.useState(true);
    const [detail, setDetail] = React.useState(null);
    const [data, setData] = React.useState([]);
    const [title, setTitle] = React.useState('Reviews');

    const { user } = useSelector(state => state.user);

    const api = {
        load: () => {
            setLoading(true);
            apiGet(
                `appraisals/${user.id}`,
                user.guid,
                response => {
                    const filteredAppraisals = response.filter(x => !x.launch || !isFuture(x.launch));
                    setData(filteredAppraisals);
                    setLoading(false);
                },
                () => history.replace('/error')
            );
        },
    };

    React.useEffect(() => {}, []);

    React.useEffect(() => {
        if (detail) {
            setTitle(e4Format(detail?.scheduled));
        } else {
            setTitle(SystemText('Reviews/Title'));
        }
    }, [detail]);

    React.useEffect(() => {
        if (user) {
            api.load();
        }
    }, [user]);

    return (
        <div id="reviews-page" data-testid="review-page">
            <PageHeader title={title} reviews={detail} hideCrumb={!detail} />
            {loading ? (
                <Loading />
            ) : detail ? (
                <ReviewDetails review={detail} reload={api.load} />
            ) : (
                <ReviewsList data={data} setDetail={setDetail} />
            )}
        </div>
    );
};

export default Reviews;
